import * as types from '../constants';
import initialState from '../initialState';

export default (state = initialState.table, action) => {
  const { type, payload } = action;
  switch (type) {
    case types.SET_TABLE_SEARCH_SUCCESS:
      return {
        ...state,
        meta: {
          ...state.meta,
          [payload.tableId]: {
            ...state.meta[payload.tableId],
            search: payload.search,
            page: 1,
          },
        },
      };
    case types.SET_TABLE_PAGE_SUCCESS:
      return {
        ...state,
        meta: {
          ...state.meta,
          [payload.tableId]: {
            ...state.meta[payload.tableId],
            page: payload.page,
          },
        },
      };
    case types.SET_TABLE_SORT_SUCCESS:
      return {
        ...state,
        meta: {
          ...state.meta,
          [payload.tableId]: {
            ...state.meta[payload.tableId],
            sort: payload.sort,
            page: 1,
          },
        },
      };
    case types.SET_TABLE_SIZE_PER_PAGE_SUCCESS:
      return {
        ...state,
        meta: {
          ...state.meta,
          [payload.tableId]: {
            ...state.meta[payload.tableId],
            sizePerPage: payload.sizePerPage,
            page: 1,
          },
        },
      };
    default:
      return state;
  }
};
